import { useQuery } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";
import type { PaperCountResponse } from "@/types/paper";

export function usePapersCount(conceptId: string | undefined) {
  return useQuery<PaperCountResponse>({
    // Separate key (NOT a child of ["papers", conceptId]) so the papers-list
    // optimistic updaters never run their `.papers`-shaped updater against this
    // count object. Freshness for the pull-based map is handled by invalidating
    // this key when the WhereAmI overlay opens.
    queryKey: ["papers-count", conceptId],
    queryFn: () =>
      apiClient.get(`api/concepts/${conceptId}/papers/count`).json(),
    enabled: !!conceptId,
  });
}
